// import { differenceInYears, differenceInMonths, differenceInWeeks, differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds, addDays, subYears, subMonths } from 'date-fns';
import differenceInYears from 'date-fns/differenceInYears';
import differenceInMonths from 'date-fns/differenceInMonths';
import differenceInWeeks from 'date-fns/differenceInWeeks';
import differenceInDays from 'date-fns/differenceInDays';
import differenceInHours from 'date-fns/differenceInHours';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import addDays from 'date-fns/addDays';
import subYears from 'date-fns/subYears';
import subMonths from 'date-fns/subMonths';
import dateFormat from "date-fns/format";
import { format, toZonedTime } from 'date-fns-tz';
import { parseISO } from 'date-fns';
// import { format, utcToZonedTime } from 'date-fns-tz';

export const timeDiffs = [
  { str: 'years', fn: differenceInYears },
  { str: 'months', fn: differenceInMonths },
  { str: 'weeks', fn: differenceInWeeks },
  { str: 'days', fn: differenceInDays },
  { str: 'hours', fn: differenceInHours },
  { str: 'minutes', fn: differenceInMinutes },
  { str: 'seconds', fn: differenceInSeconds },
];

export const getTimeDiffItem = unit => timeDiffs.find(d => d.str === unit);

export const getTimeDiff = (first, second, unit) => {
  const diffObj = getTimeDiffItem(unit);
  return diffObj.fn(first, second);
}

export const convertDate = (date, strFormat = "yyyy-MM-dd") => dateFormat(new Date(date), strFormat);

// export const convertDate_MDY = (date, strFormat = "MMM dd, yyyy") => dateFormat(new Date(date), strFormat);

export const convertDate_MDY = (date, strFormat = "MMM dd, yyyy") => {
  const parsedDate = parseISO(date);
  const newYorkTimeZone = "America/New_York";
  const formattedDate = format(parsedDate, strFormat, { timeZone: newYorkTimeZone });

  return formattedDate;
};

export const getTradingItem = (d, timeZone = 'America/New_York', prop = 'recordDate') => {
  const date = toZonedTime(new Date(d[prop]), timeZone);
  return {
    ...d,
    //[prop]: Timezone(d[prop]).tz(timeZone).format('DD MMMM YYYY, HH:mm:ss'),
    [prop]: `${format(date, 'yyyy-MM-dd', { timeZone })}T${format(date, 'HH:mm:ss', { timeZone })}`,
  };
}

export const getTimeDiffStr = (date, now = new Date()) => {
  const first = new Date(date);
  const second = new Date(now);

  let diff = 0;
  let i = 0;

  while (diff === 0 && i < timeDiffs.length) {
    diff = timeDiffs[i].fn(second, first);
    i += 1;
  }

  return i <= timeDiffs.length ? `${diff} ${timeDiffs[i - 1].str} ago` : `less than a seconds ago`;
}

export const addDaysFn = (date, amt) => addDays(new Date(date), amt);

export const subYearsFn = (date, amt) => subYears(new Date(date), amt);

export const subMonthsFn = (date, amt) => subMonths(new Date(date), amt);

export const convertTime12to24 = time12h => {
  const [time, modifier] = time12h?.split(' ');
  let [hours, minutes, seconds] = time ? time.split(':') : null;
  if (hours === '12') {
    hours = '00';
  }
  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}:${seconds}`;
};
